import {FC} from "react";
import {useTranslation} from "react-i18next";
import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {PageRoute} from "../types/PageRoute";

export const ErrorPage: FC = () => {
	const {t} = useTranslation();

	return (
		<>
			<Header />
			<div className="content">
				<div className="content__inner">
					<div className="row text-center">
						<div className="col-12">
							<h2 className="content__heading">{t("error.title")}</h2>
							<h4>
								{t("error.description")} <a href="/">{t("error.homeLink")}</a>.
							</h4>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export const ErrorPageRoute: PageRoute = {
	component: <ErrorPage />,
	route: "/404",
};
